import { render } from "./BtnDownloadMultComponent.vue?vue&type=template&id=59465722&scoped=true"
import script from "./BtnDownloadMultComponent.vue?vue&type=script&lang=js"
export * from "./BtnDownloadMultComponent.vue?vue&type=script&lang=js"

import "./BtnDownloadMultComponent.vue?vue&type=style&index=0&id=59465722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59465722"]])

export default __exports__